import { z } from 'zod';
import { EmptyObject } from 'libs/end-to-end/src/generic';
import { createCustomVizRequestSchema } from 'libs/end-to-end/src/custom-viz/createCustomVizRequestSchema';
import { FocusArea } from 'libs/end-to-end/src/focus-area';
import { FilterDefinitionForExtras } from 'libs/end-to-end/src/types/databases/filters/filter-definition';

export const BiasAnalysisExtras = z
  .object({
    dimension: z.string(),
    focusArea: FocusArea,
    metric: z.string(),
    filters: z.array(FilterDefinitionForExtras),
    /**
     * This is used in the deep dive page to show the bias analysis for a specific dimension level.
     *
     * For share link to work, we need to be able to load the filters on the page
     * based on the BiasAnalysisRequest. Without this, we'd only have the
     * dimension, but not the treatment level
     *
     * @note the backend doesn't use this field in the Python script so it's a
     * pass through
     */
    treatmentDimensionLevel: z.string().optional(),
  })
  .describe('BiasAnalysisExtras');

export type BiasAnalysisExtras = z.infer<typeof BiasAnalysisExtras>;

export const BiasAnalysisInputs = z.object({
  dropdowns: EmptyObject,
  extras: BiasAnalysisExtras,
});

export const BiasAnalysisRequest = createCustomVizRequestSchema(
  'biasAnalysis',
  BiasAnalysisInputs,
);

export type BiasAnalysisRequest = z.infer<typeof BiasAnalysisRequest>;
